/**
 * created by wang lei
 更多 页面
 *
 */
import React, {Component} from 'react';
import more from './more.png';
import onClickOutside from "react-onclickoutside";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class MoreTool extends Component {

    listenContentClick(){
        if(this.wrapper && this.wrapper.instanceRef){
            this.wrapper.instanceRef.handleClickOutside();
        }
    }

    render() {
        return <MoreToolClickOutsideWrapper ref={wrapper=>this.wrapper = wrapper}>
            {React.Children.map(this.props.children, child => child)}
        </MoreToolClickOutsideWrapper>
    }

}


class MoreToolClickOutside extends Component{

    constructor(props) {
        super(props);
        this.state = {visible:false}
    }

    hide(){
        this.setState({visible:false})
    }

    render() {
        return <div className={"editor-more-tool-btn"}>
            <span style={{position:"relative"}}>
                <span style={{cursor:"pointer"}} onClick={()=>{
                    this.setState({visible:true});
                }}>
                    <img  src={more}/>
                </span>
                <div style={{position:"absolute", display:this.state.visible?"block":"none", zIndex:999, padding:"10px 0",background:"#FFFFFF", width:130, border:"1px solid #dddbdb"}}>
                    {React.Children.map(this.props.children, child => child)}
                </div>
            </span>
            <style>{`
                .editor-more-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-more-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
            `}</style>
        </div>


    }

    handleClickOutside = (evt) => {
        this.hide();
    };
}
let MoreToolClickOutsideWrapper = onClickOutside(MoreToolClickOutside);